import api from '@/api';
import logAnalyticsEvent from '@/helpers/analytics';

export default {
    namespaced: true,

    state: {
        profiles: []
    },

    actions: {

        async fetchProfiles(context, obj) {

            let url = `/admin/users?page=${obj.page}`;
            if (obj.search) {
                url += `&search=${encodeURIComponent(obj.search)}`;
            }
            if (obj.order_by) url += `&order_by=${obj.order_by}`;
            if (obj.order_dir) url += `&order_dir=${obj.order_dir}`;
            try {
                const response = await api.request('get', url);
                return response.data;
            } catch (error) {
                throw error;
            }
        },

        async deleteProfile(context, data) {
            const url = `/admin/users/${data.item.guid}`;
            try {
              const response = await api.request('delete', url);
                context.commit('removeProfile', data.item)
                return response.data;
            } catch (error) {
              throw error;
            }
        },

        async deleteVote(context, vote) {
            const url = `/admin/votes/${vote.uid}`;
            return await api.request('delete', url);
        },
        async deleteVoteImage(context, body) {
            const url = `/admin/votes/${body.vote_guid}/images/${body.image_guid}`;
            return await api.request('delete', url)
        },

        async createNewUserManually(context, body) {
            const url = "/admin/users";
            try {
                const response = await api.request("post", url, body);
                return response.data
            } catch (error) {
                throw error;
            }
        },
        async updateProfileLang(context, langCode) {
            const user_uid = context.rootState.auth.userInfo.guid;
            const url = `/users/${user_uid}/language`;
            if (user_uid) {
                try {
                    const response = await api.request("post", url, {lang_code: langCode})
                    return response.data
                } catch (error) {
                    throw error
                }
            }

        },
    },
    mutations: {

        addProfiles(state, profiles) {
            state.profiles.push(profiles)
        },

        removeProfile(state, profiles) {
            const index = state.profiles.findIndex(item => item === profiles)
            state.profiles.splice(index, 1)
        },

        resetProfiles(state) {
            state.profiles = []
        }
    }
};
